import { useEffect } from "react";
// import { WavesAnimation } from "../../components/WavesAnimation";
import { StarsAnimation } from "../../components/StarsAnimation";
import { Header } from "../../components/Header";
import styled from "styled-components";
import { FadeOut } from "../../components/FadeOut";
import { Footer } from "../../components/Footer";
import { useLocation, useNavigate } from "react-router";
import { scrollToAnchor } from "../../utils/scroll";
import { Features } from "./Features";
import { HowItWorks } from "./HowItWorks";
import { Plates } from "./Plates";
import { Plans } from "./Plans";
import { Demo } from "./Demo";
import { Download } from "./Download";
import { FAQ } from "./FAQ";
import { TrustMetrics } from "./TrustMetrics";
// import { Testimonials } from "./Testimonials";

export const Main = () => {
  // const hours = new Date().getHours();
  // const isDayTime = hours > 5 && hours < 20;
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      scrollToAnchor(hash.slice(1));
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  return (
    <>
      <FadeOut color="black" />
      <Wrap>
        <Header />
        <div id="home">
          {/* {isDayTime ? <WavesAnimation /> : <StarsAnimation />} */}
          <StarsAnimation />
        </div>
        <TrustMetrics />
        {/* <Testimonials /> */}
        <Features />
        <HowItWorks />
        <Plates />
        <Demo />
        <Download />
        <Plans />
        <FAQ />
        <Footer />
      </Wrap>
    </>
  );
};

const Wrap = styled.div`
  width: 100%;
  background: #fcfdff;
  overflow: hidden;
`;
